module.exports = __webpack_public_path__ + "static/media/meta2.491b4ce8.gif";